// *******************************************************************************
// 1.0 - Open dropdown
// *******************************************************************************

const dropdownElement = document.querySelectorAll('.dropdown');
const dropdownPlaceholderElement = document.querySelectorAll('.dropdown__placeholder');

dropdownPlaceholderElement.forEach((el) => {
  const dropdownParent = el.closest('.dropdown');
  const dropdownOptions = dropdownParent.querySelectorAll('.dropdown__list-item');
  const dropdownSearchInput = dropdownParent.querySelector('.dropdown__search_input');

  el.addEventListener('click', () => {
    dropdownElement.forEach((elem) => {
      if (elem === dropdownParent) {
        // Is this the dropdown we clicked on? Just toggle the class
        elem.classList.toggle('is-open');
      } else {
        // Remove class from all other dropdowns on page
        elem.classList.remove('is-open');
      }
    });
  });

  if (dropdownSearchInput) {
    dropdownSearchInput.addEventListener('keyup', (evt) => {
      const searchString = evt.target.value.toLowerCase();
      dropdownOptions.forEach((option) => {
        const optionTitles = option.querySelector('input').getAttribute('data-title');
        if (!optionTitles.toLowerCase().includes(searchString)) {
          // eslint-disable-next-line no-param-reassign
          option.style.display = 'none';
        } else {
          // eslint-disable-next-line no-param-reassign
          option.style.display = 'block';
        }
      });
    });
  }
});

// *******************************************************************************
// 2.0 - Click on dropdown option
// *******************************************************************************

const dropdownOptionElement = document.querySelectorAll('.dropdown__list-option');
const getHash = () => window.location.hash.replace(/^#/, '');

dropdownOptionElement.forEach((el) => {
  el.addEventListener('click', (ev) => {
    const dropdownParent = el.closest('.dropdown');
    const dropdownPlaceholderText = dropdownParent.querySelector('.dropdown__placeholder-text');
    const dropdownOptionText = ev.target.innerHTML;

    // Change text
    if (!dropdownParent.classList.contains('dropdown--multiselect') && !dropdownParent.classList.contains('dropdown--with-search')) {
      dropdownPlaceholderText.innerHTML = dropdownOptionText;
    }

    if (dropdownParent.classList.contains('dropdown--with-search')) {
      const placeHolderInput = dropdownParent.querySelector('.dropdown__search_input');
      placeHolderInput.value = dropdownOptionText;
    }

    // Change location hash if it already exists
    const locationHash = getHash();
    if (locationHash) {
      const optionValue = ev.target.parentElement.querySelector('input').getAttribute('id');
      window.location.hash = `#${optionValue}`;
    }

    // Close the dropdown
    if (!dropdownParent.classList.contains('dropdown--multiselect')) {
      dropdownParent.classList.remove('is-open');
    }
    dropdownParent.classList.add('is-selected');

    if (ev.target.closest('.dropdown__list-item').querySelector('input').dataset.url) {
      window.location = ev.target.closest('.dropdown__list-item').querySelector('input').dataset.url;
    }
  });
});

document.addEventListener('click', (evt) => {
  const dropdownElemOpened = document.querySelector('.dropdown.is-open');
  let targetElement = evt.target; // clicked element

  do {
    if (targetElement === dropdownElemOpened) {
      return;
    }
    targetElement = targetElement.parentNode;
  } while (targetElement);

  dropdownElement.forEach((el) => {
    const dropdownParent = el.closest('.dropdown');
    dropdownParent.classList.remove('is-open');
  });
});

// **************************************************

document.querySelectorAll('.dropdown--deselect').forEach((deselect) => {
  const placeholderText = deselect.querySelector('.dropdown__placeholder-text');
  const defaultPlaceholder = placeholderText.innerHTML;

  attachEvent('.dropdown__list-option__deselect', 'click', () => {
    deselect.classList.remove('is-selected', 'is-open');
    // eslint-disable-next-line no-return-assign, no-param-reassign
    deselect.querySelectorAll('.radio').forEach((radio) => (radio.checked = false));
    placeholderText.innerHTML = defaultPlaceholder;
  });
});
